import { RedoPrintJobSchema } from "@redotech/redo-fulfillment-group-common/print-job";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const PrintQueueJobSchema = RedoPrintJobSchema.and(
  z.object({ batchNumber: z.string().optional() }),
);

export const PrintQueueStatusSchema = z.object({
  total: z.number(),
  completed: z.number(),
  failed: z.array(PrintQueueJobSchema),
  inFlight: z.array(PrintQueueJobSchema),
  activeJob: PrintQueueJobSchema.nullish(),
});

export type PrintQueueStatus = z.infer<typeof PrintQueueStatusSchema>;

const emptyPrintQueueMock = {
  total: 0,
  completed: 0,
  failed: [],
  inFlight: [],
  activeJob: null,
};

export const watchPrintQueue = unaryStreamRpc({
  name: "watchPrintQueue",
  input: z.object({}),
  output: PrintQueueStatusSchema,
  mock: emptyPrintQueueMock,
});
